import React from "react"
import PropTypes from 'prop-types'

const Calendar = ({
  style = {},
  fill = "white",
  width = "100%",
  className = "calendar",
  viewBox = "0 0 18 18"
}) => (
  <svg
    width={width}
    style={style}
    viewBox={viewBox}
    xmlns="http://www.w3.org/2000/svg"
    className={`svg-icon ${className || ""}`}
  >
    <path
      fill={fill}
      fillRule="evenodd"
      d="M15.971 8H1.997V4.971A.97.97 0 0 1 2.967 4h1.027v2H5.99V4h5.988v2h1.996V4h.999a1 1 0 0 1 .998 1v3zm0 7c0 .55-.449 1-.998 1H2.995a1 1 0 0 1-.998-1v-5H15.97v5zm-15.907.761c0 1.104.957 2.239 2.06 2.239h13.974C17.201 18 18 16.979 18 15.761c0-.389-.032-10.401-.032-11.053 0-2.082-.28-2.708-3.994-2.708V0h-1.996v2H5.99V0H3.994v2H1.997C.899 2 0 2.9 0 4l.064 11.761z"
    />
  </svg>
)

Calendar.propTypes = {
  style: PropTypes.object,
  fill: PropTypes.string,
  width: PropTypes.string,
  className: PropTypes.string,
  viewBox: PropTypes.string
}

export default Calendar
